/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import dayjs from "dayjs"
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
  ToggleButton,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { e休日区分 } from "../../../constant/enum/master"
import { e社員区分 } from "../../../constant/enum/syain"
import { e勤怠区分, 乗務員勤怠表示記号区分 } from "../../../constant/enum/unko"
import { メニューコード } from "../../../constant/menuCode"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import SyukkinboService from "../../../service/attendance/syukkinbo/syukkinboService"
import {
  TKintai,
  TSyukkinboListGetReq,
  TSyukkinboListGetRes,
} from "../../../service/attendance/syukkinbo/TSyukkinbo"
import BusyoService from "../../../service/master/busyo/busyoService"
import KyuzituService from "../../../service/master/kyuzitu/kyuzituService"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"

// #region [const]

const HeaderEndColumnIndex = 12

//#endregion

// #region [type]

export type T出勤簿リスト = TSyukkinboListGetRes & {
  行ID: symbol
  日別最大勤怠リスト_勤務: TKintai[]
  日別最大勤怠リスト_深夜: TKintai[]
}

//#endregion

/**
 * 乗務員出勤簿一覧
 * @returns
 */
const ZyomuinSyukkinboList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)
  const ref年月 = useRef<string>(eigyobi)
  const ref日曜日 = useRef<string>()
  const ref日数 = useRef<number>(0)

  // 休日対応
  let refHolidayList = useRef<Array<{ 休日: string }>>([])

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  const 表示切替リスト: Array<{ value: number; name: string }> = [
    { value: 1, name: "勤務" },
    { value: 2, name: "深夜" },
    { value: 3, name: "警告" },
    { value: 4, name: "安全会議" },
  ]
  const 勤怠記号DataMap = new wjcGrid.DataMap<{
    区分コード: string
    表示記号: string
  }>(乗務員勤怠表示記号区分, "区分コード", "表示記号")

  //TODO:ページ名称確定必須
  let gridId = "ZyomuinSyukkinboList_GridId"

  //#region [method]

  /**
   * 検索条件の年月から対象月の日数を返却
   */
  const getLastDay = () => {
    const endDate = dayjs(ref年月.current).add(1, "month").date(0).toDate()
    const lastDay = dayjs(endDate).format("DD")
    return parseInt(lastDay)
  }

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TSyukkinboListGetRes>,
    pageSize: number,
    表示切替: number
  ) => {
    // 当月分の日数リスト
    let dList: number[] = []
    // 当月の最大日数取得
    let cnt = getLastDay()
    // 当月の日数分を日数リストへ格納
    for (let k = 1; k < cnt + 1; k++) {
      dList.push(k)
    }

    // Grid用データ作成
    let gridItems = toGridItems(data, dList)

    // 表示切替に対応するため、Calcフィールドとして日付Column作成
    let 日付リスト: any = {}

    // 日数リスト分のColumn設定を日付リストへ格納する
    switch (表示切替) {
      // TODO:3(警告)と4(安全会議) は2時開発
      case 1:
      case 3:
      case 4:
        dList.forEach((element: number) => {
          日付リスト[`day_${element}`] = (i: T出勤簿リスト) => {
            const 最大勤怠データ = i.日別最大勤怠リスト_勤務.find((k) => {
              // 勤務日から日付のみ取得
              let d = parseInt(dayjs(k.勤務日).format("D"))
              return element === d
            })

            if (最大勤怠データ == null) return ""

            // 有休、特休の場合は勤怠区分コードを返す
            // 同日に複数あった場合、大きい数値のほうを表示する
            if (
              最大勤怠データ.勤怠区分コード === e勤怠区分.有給休暇 ||
              最大勤怠データ.勤怠区分コード === e勤怠区分.特別休暇
            ) {
              return 最大勤怠データ.勤怠区分コード
            } else {
              return 最大勤怠データ.勤務記号区分コード ?? ""
            }
          }
        })
        break
      case 2:
        dList.forEach((element: number) => {
          日付リスト[`day_${element}`] = (i: T出勤簿リスト) => {
            const 最大勤怠データ = i.日別最大勤怠リスト_深夜.find((k) => {
              // 勤務日から日付のみ取得
              let d = parseInt(dayjs(k.勤務日).format("D"))
              return element === d
            })

            if (最大勤怠データ == null) return ""
            return 最大勤怠データ.深夜記号区分コード ?? ""
          }
        })
        break
    }

    return new wjCore.CollectionView(gridItems, {
      pageSize,
      calculatedFields: {
        // TODO:カレンダーをdayjs使う＆祝日カレンダー（DB)の値で休みか判定する必要ある。
        勤怠日数_出勤: (i: T出勤簿リスト) => {
          return i.日別最大勤怠リスト_勤務.reduce((result, data) => {
            return result + (data.勤務記号区分少数値1 ?? 0)
          }, 0)
        },
        勤怠日数_夜勤: (i: T出勤簿リスト) => {
          return i.日別最大勤怠リスト_深夜.reduce((result, data) => {
            return result + (data.深夜記号区分少数値1 ?? 0)
          }, 0)
        },
        勤怠日数_休出: (i: T出勤簿リスト) => {
          const 休日data = i.勤怠リスト.filter((d) => d.日曜フラグ === 1)
          return 休日data.reduce((result, data) => {
            return result + (data.勤務記号区分少数値1 ?? 0)
          }, 0)
        },
        勤怠日数_祝出: (i: T出勤簿リスト) => {
          const 休日data = i.勤怠リスト.filter(
            (d) => d.日曜フラグ === 0 && d.祝日フラグ === 1
          )
          return 休日data.reduce((result, data) => {
            return result + (data.勤務記号区分少数値1 ?? 0)
          }, 0)
        },

        勤怠日数_特休: (i: T出勤簿リスト) => {
          let cnt: number = 0
          i.勤怠リスト.forEach((d) => {
            if (d.勤怠区分コード === e勤怠区分.特別休暇) cnt = cnt + 1
          })
          return cnt
        },
        勤怠日数_有給: (i: T出勤簿リスト) => {
          let cnt: number = 0
          i.勤怠リスト.forEach((d) => {
            if (d.勤怠区分コード === e勤怠区分.有給休暇) cnt = cnt + 1
          })
          return cnt
        },
        運行外業務_集計: (i: T出勤簿リスト) => {
          return i.勤怠リスト.reduce((result, data) => {
            return result + (data.運行外業務記号区分少数値1 ?? 0)
          }, 0)
        },
        padding社員コード: (data: T出勤簿リスト) =>
          data.社員コード != null && data.社員コード !== ""
            ? data.社員コード?.padStart(4, "0")
            : "9999",
        ...日付リスト,
      },
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  /**
   * Grid用アイテムコンバート処理
   */
  const toGridItems = (
    data: Array<TSyukkinboListGetRes>,
    dList: number[]
  ): T出勤簿リスト[] => {
    return data.map((dataItem): T出勤簿リスト => {
      let 日別最大勤怠リスト_勤務: TKintai[] = []
      let 日別最大勤怠リスト_深夜: TKintai[] = []

      // 日別に勤務・深夜で最大のTkintaiを割り出して日別最大勤怠リストに設定しておく
      dList.forEach((element: number) => {
        const 日別リスト = dataItem.勤怠リスト.filter((item) => {
          // 勤務日から日付のみ取得
          let d = parseInt(dayjs(item.勤務日).format("D"))
          return element === d
        })

        // 勤務用にソートし、最大レコードを保持
        const ソート済み日別リスト_勤務 = 日別リスト.sort((a, b) => {
          if ((a.勤務記号区分数値1 ?? 0) < (b.勤務記号区分数値1 ?? 0)) return 1
          if ((b.勤務記号区分数値1 ?? 0) < (a.勤務記号区分数値1 ?? 0)) return -1
          return 0
        })
        if (
          ソート済み日別リスト_勤務 != null &&
          ソート済み日別リスト_勤務.length !== 0
        )
          日別最大勤怠リスト_勤務.push(ソート済み日別リスト_勤務[0])

        // 深夜用にソートし、最大レコードを保持
        const ソート済み日別リスト_深夜 = 日別リスト.sort((a, b) => {
          if ((a.深夜記号区分数値1 ?? 0) < (b.深夜記号区分数値1 ?? 0)) return 1
          if ((b.深夜記号区分数値1 ?? 0) < (a.深夜記号区分数値1 ?? 0)) return -1
          return 0
        })
        if (
          ソート済み日別リスト_深夜 != null &&
          ソート済み日別リスト_深夜.length !== 0
        )
          日別最大勤怠リスト_深夜.push(ソート済み日別リスト_深夜[0])
      })

      return {
        ...dataItem,
        行ID: Symbol(),
        日別最大勤怠リスト_勤務: 日別最大勤怠リスト_勤務,
        日別最大勤怠リスト_深夜: 日別最大勤怠リスト_深夜,
      }
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TSyukkinboListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    flexGrid?.select(-1, -1)

    let currentSearchCondition: TSyukkinboListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new SyukkinboService().zyomuinGetList(
        currentSearchCondition
      )
      // 検索結果をstateにセット
      setResData(
        res.data
          .filter((d) => d.社員区分コード === e社員区分.乗務員)
          .sort((a, b) => {
            if (a.社員コード.padStart(4, "0") > b.社員コード.padStart(4, "0"))
              return 1
            if (a.社員コード.padStart(4, "0") < b.社員コード.padStart(4, "0"))
              return -1
            return 0
          })
      )

      setGridData({
        data: createCollectionView(
          res.data
            .filter((d) => d.社員区分コード === e社員区分.乗務員)
            .sort((a, b) => {
              if (a.社員コード.padStart(4, "0") > b.社員コード.padStart(4, "0"))
                return 1
              if (a.社員コード.padStart(4, "0") < b.社員コード.padStart(4, "0"))
                return -1
              return 0
            }),
          pageSize,
          1
        ),
      })
      const kyuzituRes = await new KyuzituService().getList({
        検索年: currentSearchCondition.年月,
      })

      kyuzituRes.data
        .filter(
          (d) =>
            d.休日区分コード === e休日区分.祝日 ||
            d.休日区分コード === e休日区分.会社休日
        )
        .forEach((i) => {
          refHolidayList.current.push({
            休日: i.休日日付,
          })
        })

      // formatItemを入れなおすためフラグを切り替え
      ref明細フォーマットフラグ.current = false
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TSyukkinboListGetReq = queryString.parse(location.search)
    set年月(query.年月)
    set部所コード(query.部所コード ?? "")
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TSyukkinboListGetReq => {
    return {
      年月: 年月 ?? new Date().toISOString(),
      部所コード: 部所コード ?? undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TSyukkinboListGetReq
  ) => {
    const disp年月 = dayjs(searchCondition.年月).format("YYYY/MM")

    const disp部所 = 部所ItemSource?.find(
      (i) => i.部所コード === searchCondition.部所コード
    )
    return {
      年月: wjCore.isNullOrWhiteSpace(disp年月 ?? "") ? "" : disp年月,
      部所: disp部所
        ? `${disp部所.部所コード} ${disp部所.部所略称}`
        : undefined,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize, 表示切替)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    set年月(eigyobi)
    ref年月.current = eigyobi
    ref日数.current = 0
    ref明細フォーマットフラグ.current = false

    set部所コード("")
    set部所(undefined)
    set部所ItemSource(undefined)
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    let extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    // ヘッダの設定
    grid.formatItem.addHandler(formatItem)
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    // ループをフラグで制御？
    if (ref明細フォーマットフラグ.current) return

    const 所属binding = ["部所略称", "社員コード", "社員氏名"]
    let columnHeaders = f.columnHeaders

    // Date変換
    let targetDate = eigyobi
    if (ref年月.current != null) targetDate = ref年月.current
    // 対象の年月までを設定する
    let ymDate = dayjs(targetDate).format("YYYYMM")

    columnHeaders.columns.forEach((c, index) => {
      // 固定部分
      if (c.binding != null) {
        if (所属binding.includes(c.binding)) {
          columnHeaders.setCellData(0, index, "所属")
        } else if (c.binding.includes("勤怠日数")) {
          columnHeaders.setCellData(0, index, "勤怠日数")
        } else if (c.binding.includes("休暇取得")) {
          columnHeaders.setCellData(0, index, "休暇取得")
        } else if (c.binding.includes("就業時間")) {
          columnHeaders.setCellData(0, index, "就業時間")
        } else if (c.binding.includes("有休残数")) {
          columnHeaders.setCellData(0, index, "有休残数")
        } else if (c.binding.includes("労務警告")) {
          columnHeaders.setCellData(0, index, "労務警告")
        } else if (c.binding.includes("安全会議")) {
          columnHeaders.setCellData(0, index, "安全会議")
        } else if (c.binding.includes("運行外業務_集計")) {
          columnHeaders.setCellData(0, index, "運行外業務")
        }
      }
      // 日付部分
      // 対象月の日数取得
      let cnt = getLastDay()
      // 日数分の設定
      for (let i = 1; i < cnt + 1; i++) {
        let day = "day_" + i
        if (c.binding === day) {
          // 対象月のYYYYMMにDD部分を合わせる
          let target = ymDate + i
          // 曜日を取得
          let str = dayjs(target).format("ddd")
          columnHeaders.setCellData(0, index, i) // 日付
          columnHeaders.setCellData(1, index, str) // 曜日

          // 休日カレンダー判定
          let sundayCssClass = "holiday-color"
          // css設定済みフラグ
          let isCssClass = false

          // columnの日付生成
          const ret = ("00" + i).slice(-2) // 0埋め
          const colDate = dayjs(targetDate).format("YYYY/MM") + "/" + ret

          const tmp曜日 = dayjs(colDate).format("ddd")
          let hList = []
          refHolidayList.current.forEach((d) => {
            // 列の日付が祝日リストに存在するか判定
            if (dayjs(d.休日).format("YYYY/MM/DD") === colDate) {
              hList.push(d)
            }
          })
          // 列の日付が休日だった場合、CSSを設定する
          const columnIndex = i + HeaderEndColumnIndex
          if (tmp曜日 === ref日曜日.current) {
            columnHeaders.columns[columnIndex].cssClassAll = sundayCssClass
            isCssClass = true
          } else if (hList.length > 0 && !isCssClass) {
            columnHeaders.columns[columnIndex].cssClassAll = sundayCssClass
            isCssClass = true
          } else {
            columnHeaders.columns[columnIndex].cssClassAll = ""
          }
        }
      }

      c.allowMerging = true
      c.align = "center"
    })

    // フォーマットのループ制御
    ref明細フォーマットフラグ.current = true
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(15)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize, 1),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]

  const [年月, set年月] = useState<string | null>()

  const [部所コード, set部所コード] = useState<string | null>()
  const [, set部所] = useState<T部所マスタ | null>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [表示切替, set表示切替] = useState<number>(1)
  const [resData, setResData] = useState<TSyukkinboListGetRes[]>([])

  //#region comboboxState
  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)

  const [isComboboxItemInitialised, setIsComboboxItemInitialised] =
    useState(false)
  //#endregion

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `出勤簿一覧`
    // 初期表示生成のため画面ロック
    ref日数.current = getLastDay()

    dispatch(画面ロック開始())
  }, [])

  useEffect(() => {
    if (!年月) return
    ref年月.current = 年月

    // 対象月の日数取得
    ref日数.current = getLastDay()
  }, [年月])

  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KyuzituService().getList({ 検索年: eigyobi }),
    ]).then(([部所ListRes, 休日マスタRes]) => {
      set部所ItemSource(部所ListRes.data)

      const SyukujizuRes = 休日マスタRes.data.filter(
        (d) => d.休日区分コード === e休日区分.祝日
      )
      SyukujizuRes.forEach((i) => {
        refHolidayList.current.push({
          休日: i.休日日付,
        })
      })
      ref日曜日.current = "日"
      ref明細フォーマットフラグ.current = false
      setIsComboboxItemInitialised(true)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && 部所ComboBox && isComboboxItemInitialised) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, 部所ComboBox, isComboboxItemInitialised])

  // 表示切替　CollectionViewを入れなおす
  useEffect(() => {
    if (gridInitialized) {
      setGridData({
        data: createCollectionView(resData, pageSize, 表示切替),
      })
      flexGrid?.refresh()
    }
  }, [表示切替])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">乗務員出勤簿一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-60rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-8rem">
                              <MonthInput
                                id="年月"
                                value={年月}
                                setValue={set年月}
                                isRequired
                                placeholder="年月"
                                defaultValue={eigyobi}
                                autoFocus={true}
                              />
                            </div>
                            <ComboBox.Busyo
                              placeholder="部所"
                              itemsSource={部所ItemSource}
                              isLoadEnded={部所IsLoadEnded}
                              setIsLoadEnded={set部所IsLoadEnded}
                              setSelectedValue={set部所コード}
                              listFilter={(d) => d.運行部所フラグ === 1}
                              selectedValue={部所コード}
                              setSelectedItem={set部所}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}></ComboBox.Busyo>
                          </div>
                        </div>
                      </Col>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={false}
                hasFilter={false}
                gridProperties={{
                  frozenColumns: 3,
                  allowSorting: wjcGrid.AllowSorting.None,
                  allowDragging: wjcGrid.AllowDragging.None,
                }}
                headerComponent={
                  <>
                    <ButtonGroup>
                      {表示切替リスト.map((radio, idx, arr) => (
                        <ToggleButton
                          key={idx}
                          id={`radio-${radio.name}`}
                          type="radio"
                          variant={"outline-success"}
                          name="radio"
                          size="lg"
                          className="fs-5"
                          value={radio.value}
                          checked={表示切替 === radio.value}
                          onChange={(e) =>
                            set表示切替(parseInt(e.currentTarget.value))
                          }>
                          {radio.name}
                        </ToggleButton>
                      ))}
                    </ButtonGroup>
                  </>
                }>
                {/* ここから固定列 Start */}
                <wjrGrid.FlexGridColumn
                  binding="部所略称"
                  cssClass="text-start"
                  width={120}
                  header="部所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員コード"
                  sortMemberPath={"padding社員コード"}
                  cssClass="text-start"
                  width={70}
                  header="社員番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員氏名"
                  cssClass="text-start"
                  width={128}
                  header="氏名">
                  {/* TODO:buttonじゃなくてaタグで遷移させたい。別Tab対応も考慮。 */}
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T出勤簿リスト>
                    ) => {
                      return (
                        <button
                          className="link-button text-primary"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )
                            const path = util.getMenuPath(
                              メニューコード.勤怠管理.乗務員出勤簿
                            )
                            history.push(
                              path[0]
                                .replaceAll(
                                  ":id",
                                  context.item.社員ID.toString()
                                )
                                .replaceAll(
                                  ":date",
                                  dayjs(ref年月.current).format("YYYY-MM-DD")
                                )
                            )
                          }}>
                          {context.item.社員氏名}
                        </button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                {/* ここまで固定列 End */}
                {/* 以下スクロール列 */}
                <wjrGrid.FlexGridColumn
                  binding="勤怠日数_出勤"
                  cssClass="text-end"
                  width={60}
                  format="n2"
                  align="right"
                  header="勤務"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="勤怠日数_夜勤"
                  cssClass="text-end"
                  width={60}
                  format="n2"
                  align="right"
                  header="深夜"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="勤怠日数_休出"
                  cssClass="text-end"
                  width={60}
                  format="n2"
                  align="right"
                  header="休出"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="勤怠日数_祝出"
                  cssClass="text-end"
                  width={60}
                  format="n2"
                  align="right"
                  header="祝出"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="勤怠日数_特休"
                  cssClass="text-end"
                  width={60}
                  format="n0"
                  align="right"
                  header="特休"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="勤怠日数_有給"
                  cssClass="text-end"
                  width={60}
                  format="n0"
                  align="right"
                  header="有休"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="有休残数"
                  cssClass="text-end"
                  wordWrap={true}
                  width={50}
                  format="n2"
                  align="right"
                  header="有休残数"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="労務警告"
                  cssClass="text-end"
                  wordWrap={true}
                  width={50}
                  header="労務警告"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="安全会議"
                  wordWrap={true}
                  cssClass="text-end"
                  width={50}
                  header="安全会議"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="運行外業務_集計"
                  wordWrap={true}
                  cssClass="text-end"
                  width={60}
                  header="運行外業務"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_1"
                  wordWrap={true}
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="1日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_2"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="2日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_3"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="3日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_4"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="4日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_5"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="5日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_6"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="6日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_7"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="7日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_8"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="8日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_9"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="9日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_10"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="10日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_11"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="11日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_12"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="12日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_13"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="13日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_14"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="14日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_15"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="15日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_16"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="16日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_17"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="17日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_18"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="18日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_19"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="19日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_20"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="20日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_21"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="21日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_22"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="22日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_23"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="23日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_24"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="24日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_25"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="25日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_26"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="26日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="day_27"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="27日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  visible={28 <= ref日数.current}
                  binding="day_28"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="28日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  visible={29 <= ref日数.current}
                  binding="day_29"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="29日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  visible={30 <= ref日数.current}
                  binding="day_30"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="30日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  visible={31 <= ref日数.current}
                  binding="day_31"
                  dataMap={勤怠記号DataMap}
                  width={45}
                  header="31日"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default ZyomuinSyukkinboList
